import { DocumentKind } from '../enums/document-kind.enum.js';
export { DocumentKind };
export var DunningStage;
(function (DunningStage) {
    DunningStage["PAYMENT_REMINDER"] = "payment_reminder";
    DunningStage["FIRST_NOTICE"] = "first_notice";
    DunningStage["FINAL_NOTICE"] = "final_notice";
})(DunningStage || (DunningStage = {}));
//# sourceMappingURL=types.js.map